import "./App.css"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Crick from "./components/crick"
import NotFound from "./components/notFound"
import HomePage from "./components/HomePage"
import LivePage from "./components/LivePage"

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/:matchId/:matchType" element={<Crick />} />
				<Route path="/liveMatch/:matchId/:matchType" element={<LivePage/>} />
				<Route path="/quick-app/:matchId/:matchType" element={<Crick />} />
				<Route path="/quick-app/:matchId/:matchType" element={<LivePage/>} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</Router>
	)
}

export default App